export default __webpack_public_path__ + "static/media/SESAME-logo.5f4827fe.png";